webpackJsonp([100103856527994],{

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Recaptcha = __webpack_require__(37);
	
	var _Recaptcha2 = _interopRequireDefault(_Recaptcha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      firstName: '',
	      firstNameValid: false,
	      lastName: '',
	      lastNameValid: false,
	      email: '',
	      emailValid: false,
	      phone: '',
	      phoneValid: false,
	      text: '',
	      textValid: props.hideMessageField,
	      recaptchaComplete: false,
	      inflight: false,
	      successMessage: null,
	      errorMessage: null,
	      formVersion: 0,
	      template: props.template,
	      additionalFields: props.additionalFields,
	      additionalFieldsValid: props.additionalFieldsValid
	    };
	
	    _this.successMessageTimeout = null;
	    _this.errorMessageTimeout = null;
	    _this.successMessage = _this.successMessage.bind(_this);
	    _this.errorMessage = _this.errorMessage.bind(_this);
	    _this.resetForm = _this.resetForm.bind(_this);
	    _this.handleRecaptchaChange = _this.handleRecaptchaChange.bind(_this);
	    _this.handleFirstNameChange = _this.handleFirstNameChange.bind(_this);
	    _this.handleLastNameChange = _this.handleLastNameChange.bind(_this);
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handlePhoneChange = _this.handlePhoneChange.bind(_this);
	    _this.handleTextChange = _this.handleTextChange.bind(_this);
	    _this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
	    return _this;
	  }
	
	  Contact.prototype.resetForm = function resetForm() {
	    this.setState({
	      firstName: '',
	      firstNameValid: false,
	      lastName: '',
	      lastNameValid: false,
	      email: '',
	      emailValid: false,
	      phone: '',
	      phoneValid: false,
	      text: '',
	      textValid: this.props.hideMessageField,
	      recaptchaComplete: false,
	      inflight: false,
	      formVersion: this.state.formVersion + 1
	    });
	  };
	
	  Contact.prototype.successMessage = function successMessage(_successMessage) {
	    var _this2 = this;
	
	    if (this.successMessageTimeout !== null) {
	      clearTimeout(this.successMessageTimeout);
	      this.successMessageTimeout = null;
	    }
	
	    this.successMessageTimeout = setTimeout(function () {
	      _this2.setState({ successMessage: null });
	    }, 10000);
	
	    this.setState({ successMessage: _successMessage, errorMessage: null });
	  };
	
	  Contact.prototype.errorMessage = function errorMessage(_errorMessage) {
	    var _this3 = this;
	
	    if (this.errorMessageTimeout !== null) {
	      clearTimeout(this.errorMessageTimeout);
	      this.errorMessageTimeout = null;
	    }
	
	    this.errorMessageTimeout = setTimeout(function () {
	      _this3.setState({ errorMessage: null });
	    }, 5000);
	
	    this.setState({ errorMessage: _errorMessage, successMessage: null });
	  };
	
	  Contact.prototype.handleRecaptchaChange = function handleRecaptchaChange(recaptcha) {
	    this.setState({ recaptcha: recaptcha, recaptchaComplete: recaptcha !== null });
	  };
	
	  Contact.prototype.handleFirstNameChange = function handleFirstNameChange(event) {
	    var firstName = event.target.value;
	    this.setState({ firstName: firstName, firstNameValid: firstName.trim().length > 0 });
	  };
	
	  Contact.prototype.handleLastNameChange = function handleLastNameChange(event) {
	    var lastName = event.target.value;
	    this.setState({ lastName: lastName, lastNameValid: lastName.trim().length > 0 });
	  };
	
	  Contact.prototype.handleEmailChange = function handleEmailChange(event) {
	    var emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    var email = event.target.value;
	    this.setState({ email: email, emailValid: emailFormat.test(String(email).toLowerCase()) });
	  };
	
	  Contact.prototype.handlePhoneChange = function handlePhoneChange(event) {
	    var phone = String(event.target.value || '').replace(/[^\d().+ -]/g, '').replace(/\s+/, ' ');
	    this.setState({ phone: phone, phoneValid: phone.replace(/[^\d]/g, '').length >= 10 });
	  };
	
	  Contact.prototype.handleTextChange = function handleTextChange(event) {
	    var text = event.target.value;
	    var textValid = text.trim().length > 10;
	    this.setState({ text: text, textValid: textValid });
	  };
	
	  Contact.prototype.handleFormSubmission = function handleFormSubmission(event) {
	    var _this4 = this;
	
	    event.preventDefault();
	    this.setState({ inflight: true });
	    var _state = this.state,
	        firstName = _state.firstName,
	        lastName = _state.lastName,
	        email = _state.email,
	        phone = _state.phone,
	        text = _state.text,
	        template = _state.template,
	        additionalFields = _state.additionalFields,
	        recaptcha = _state.recaptcha;
	
	
	    $.ajax({
	      type: "POST",
	      url: 'https://us-central1-cs-site-209414.cloudfunctions.net/contactUsEmail',
	      data: JSON.stringify(_extends({}, additionalFields, {
	        firstName: firstName,
	        lastName: lastName,
	        email: email,
	        phone: phone,
	        text: (text || '') + "\n\n\n" + (this.props.messageAddition || ''),
	        recaptcha: recaptcha,
	        template: template
	      })),
	      success: function success(response) {
	        _this4.resetForm();
	        _this4.successMessage('Your message was successfully sent!');
	      },
	      dataType: 'json',
	      contentType: 'application/json'
	    }).fail(function (_ref) {
	      var responseJSON = _ref.responseJSON;
	
	      _this4.errorMessage(responseJSON.message);
	      window.scrollTo(0, 0);
	    }).always(function () {
	      return _this4.setState({ inflight: false });
	    });
	  };
	
	  Contact.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var _props = this.props,
	        additionalFields = _props.additionalFields,
	        additionalFieldsValid = _props.additionalFieldsValid;
	
	
	    if (JSON.stringify(additionalFields) !== JSON.stringify(this.state.additionalFields)) {
	      this.setState({ additionalFields: additionalFields });
	    }
	
	    if (additionalFieldsValid !== this.state.additionalFieldsValid) {
	      this.setState({ additionalFieldsValid: additionalFieldsValid });
	    }
	  };
	
	  Contact.prototype.render = function render() {
	    var _state2 = this.state,
	        firstName = _state2.firstName,
	        firstNameValid = _state2.firstNameValid,
	        lastName = _state2.lastName,
	        lastNameValid = _state2.lastNameValid,
	        email = _state2.email,
	        emailValid = _state2.emailValid,
	        phone = _state2.phone,
	        phoneValid = _state2.phoneValid,
	        text = _state2.text,
	        textValid = _state2.textValid,
	        additionalFieldsValid = _state2.additionalFieldsValid,
	        recaptchaComplete = _state2.recaptchaComplete,
	        inflight = _state2.inflight,
	        successMessage = _state2.successMessage,
	        errorMessage = _state2.errorMessage;
	
	
	    var formValid = firstNameValid && lastNameValid && emailValid && phoneValid && textValid && additionalFieldsValid && recaptchaComplete;
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.noCard ? "" : "card card-contact" },
	      _react2.default.createElement(
	        'form',
	        { id: 'contact-form', method: 'post' },
	        this.props.title && _react2.default.createElement(
	          'div',
	          { className: 'card-header card-header-raised card-header-primary text-center' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'card-title' },
	            this.props.title || 'Contact Us'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              this.props.header || ''
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row bmd-form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group label-floating is-filled bmd-form-group ' + (!inflight && firstName.length > 0 ? firstNameValid ? 'has-success' : 'has-danger' : '') },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'bmd-label-floating' },
	                  'First name'
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'name', className: 'form-control', value: firstName, onChange: this.handleFirstNameChange, disabled: inflight }),
	                _react2.default.createElement('span', { className: 'material-input' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group label-floating is-filled bmd-form-group ' + (!inflight && lastName.length > 0 ? lastNameValid ? 'has-success' : 'has-danger' : '') },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'bmd-label-floating' },
	                  'Last name'
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'name', className: 'form-control', value: lastName, onChange: this.handleLastNameChange, disabled: inflight }),
	                _react2.default.createElement('span', { className: 'material-input' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group label-floating is-filled bmd-form-group ' + (!inflight && email.length > 0 ? emailValid ? 'has-success' : 'has-danger' : '') },
	            _react2.default.createElement(
	              'label',
	              { className: 'bmd-label-floating' },
	              'Email address'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'email', className: 'form-control', value: email, onChange: this.handleEmailChange, disabled: inflight }),
	            _react2.default.createElement('span', { className: 'material-input' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group label-floating is-filled bmd-form-group ' + (!inflight && phone.length > 0 ? phoneValid ? 'has-success' : 'has-danger' : '') },
	            _react2.default.createElement(
	              'label',
	              { className: 'bmd-label-floating' },
	              'Phone number'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'phone', className: 'form-control', value: phone, onChange: this.handlePhoneChange, disabled: inflight }),
	            _react2.default.createElement('span', { className: 'material-input' })
	          ),
	          !this.props.hideMessageField && _react2.default.createElement(
	            'div',
	            { className: 'form-group label-floating is-filled bmd-form-group ' + (!inflight && text.length > 0 ? textValid ? 'has-success' : 'has-danger' : '') },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'exampleMessage1', className: 'bmd-label-floating' },
	              'Your Message ',
	              text.length > 0 && !textValid && ' - Please elaborate on your request.'
	            ),
	            _react2.default.createElement('textarea', { name: 'message', className: 'form-control', id: 'exampleMessage1', rows: '6', value: text, onChange: this.handleTextChange, disabled: inflight }),
	            _react2.default.createElement('span', { className: 'material-input' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row bmd-form-group' },
	            _react2.default.createElement(_Recaptcha2.default, {
	              formVersion: this.state.formVersion,
	              id: 'g-recaptcha-contact',
	              sitekey: '6LcNJmUUAAAAAKJXj6v238WrsmD-Nf4au_XKmxF3',
	              onRecaptchaChange: this.handleRecaptchaChange })
	          ),
	          successMessage && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'alert-icon' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'material-icons' },
	                  'info_outline'
	                )
	              ),
	              _react2.default.createElement(
	                'b',
	                null,
	                successMessage
	              )
	            )
	          ),
	          errorMessage && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'alert-icon' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'material-icons' },
	                  'error_outline'
	                )
	              ),
	              _react2.default.createElement(
	                'b',
	                null,
	                errorMessage
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary pull-right', disabled: !formValid || inflight, onClick: this.handleFormSubmission },
	              !inflight ? this.props.submitLabel || 'Send Message' : 'Sending ...'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	Contact.defaultProps = {
	  template: 'contactUs',
	  additionalFields: {},
	  additionalFieldsValid: true,
	  hideMessageField: false
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Recaptcha = function (_React$Component) {
	  _inherits(Recaptcha, _React$Component);
	
	  function Recaptcha(props) {
	    _classCallCheck(this, Recaptcha);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Recaptcha.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.formVersion !== this.props.formVersion) {
	      grecaptcha.reset(this._id);
	    }
	  };
	
	  Recaptcha.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var clearRecaptcha = function clearRecaptcha(v) {
	      _this2.props.onRecaptchaChange(null);
	      grecaptcha.reset(_this2._id);
	    };
	
	    var i = setInterval(function () {
	      if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render == 'function') {
	        clearInterval(i);
	        _this2._id = grecaptcha.render(_this2.props.id, {
	          sitekey: _this2.props.sitekey,
	          callback: _this2.props.onRecaptchaChange,
	          'expired-callback': clearRecaptcha,
	          'error-callback': clearRecaptcha
	        });
	      }
	    }, 500);
	  };
	
	  Recaptcha.prototype.render = function render() {
	    return _react2.default.createElement('div', { id: this.props.id, style: { height: 100, marginLeft: 15 } });
	  };
	
	  return Recaptcha;
	}(_react2.default.Component);
	
	Recaptcha.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  sitekey: _propTypes2.default.string.isRequired,
	  onRecaptchaChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = Recaptcha;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Contact = __webpack_require__(53);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RentalItemRow = function RentalItemRow(_ref) {
	  var selected = _ref.selected,
	      label = _ref.label,
	      quantity = _ref.quantity,
	      cost = _ref.cost,
	      multiple = _ref.multiple,
	      onQuantityChange = _ref.onQuantityChange,
	      onSelectChange = _ref.onSelectChange;
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'td',
	      { className: 'text-center', style: { width: '3%' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'form-check' },
	        _react2.default.createElement(
	          'label',
	          { className: 'form-check-label' },
	          _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: '', checked: selected, onClick: onSelectChange }),
	          _react2.default.createElement(
	            'span',
	            { className: 'form-check-sign' },
	            _react2.default.createElement('span', { className: 'check' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        label
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'text-center' },
	      selected && multiple && _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-info btn-round btn-just-icon btn-sm', onClick: function onClick() {
	            return onQuantityChange(parseInt(quantity) - 1);
	          } },
	        _react2.default.createElement(
	          'i',
	          { className: 'material-icons' },
	          'remove'
	        ),
	        _react2.default.createElement('div', { className: 'ripple-container' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { padding: '0 10px' } },
	        quantity
	      ),
	      selected && multiple && _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-info btn-round btn-just-icon btn-sm', onClick: function onClick() {
	            return onQuantityChange(parseInt(quantity) + 1);
	          } },
	        _react2.default.createElement(
	          'i',
	          { className: 'material-icons' },
	          'add'
	        ),
	        _react2.default.createElement('div', { className: 'ripple-container' })
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'text-right' },
	      '$ ',
	      cost
	    )
	  );
	};
	
	var RentalsPage = function (_React$Component) {
	  _inherits(RentalsPage, _React$Component);
	
	  function RentalsPage(props) {
	    _classCallCheck(this, RentalsPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      rentalItems: [{ heading: 'Barbells & Plates' }, { label: '5 lbs plates (2)', cost: 5, deposit: 20 }, { label: '15 lbs plates (2)', cost: 7, deposit: 60 }, { label: '25 lbs plates (2)', cost: 10, deposit: 100 }, { label: '35 lbs plates (2)', cost: 13, deposit: 160 }, { label: '45 lbs plates (2)', cost: 16, deposit: 180, multiple: true }, { label: 'silencer mats (2)', cost: 10, deposit: 150 }, { label: 'Olympic barbell (45 lbs, 7 ft) with clips', cost: 25, deposit: 200 }, { label: 'squat rack', cost: 15, deposit: 160 }, { label: 'bench', cost: 15, deposit: 200 }, { heading: 'Conditioning/Cardio' }, { label: 'Concept2 (PM5) rower', cost: 100, deposit: 400 }, { label: 'Rogue Echo bike', cost: 100, deposit: 400 },
	      // {label: 'rings (2)', cost: 5},
	      { heading: 'Kettlebells' }, { label: '18 lbs kettlebell', cost: 5, deposit: 40 }, { label: '26 lbs kettlebell', cost: 5, deposit: 50 },
	      // {label: '35 lbs kettlebell', cost: 5},
	      // {label: '45 lbs kettlebell', cost: 5},
	      { label: '53 lbs kettlebell', cost: 5, deposit: 80 }]
	    };
	    _this._handleSelectChange = _this._handleSelectChange.bind(_this);
	    _this._handleQuantityChange = _this._handleQuantityChange.bind(_this);
	    return _this;
	  }
	
	  RentalsPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    window.fetch(this.props.wodUrl).then(function (res) {
	      var status = res.status;
	
	      return status >= 200 && status < 400 ? res.text() : null;
	    }).then(function (content) {
	      return _this2.setState({ content: content });
	    }).catch(function (err) {
	      return _this2.setState({ failedFetch: true });
	    });
	  };
	
	  RentalsPage.prototype._handleSelectChange = function _handleSelectChange(idx) {
	    var _this3 = this;
	
	    return function (e) {
	      var rentalItems = _this3.state.rentalItems.map(function (r, i) {
	        return _extends({}, r, i === idx ? { selected: e.target.checked, quantity: e.target.checked ? 1 : 0 } : {});
	      });
	      _this3.setState({ rentalItems: rentalItems });
	    };
	  };
	
	  RentalsPage.prototype._handleQuantityChange = function _handleQuantityChange(idx) {
	    var _this4 = this;
	
	    return function (quantity) {
	      var rentalItems = _this4.state.rentalItems.map(function (r, i) {
	        return _extends({}, r, i === idx ? { quantity: quantity, selected: quantity ? r.selected : false } : {});
	      });
	      _this4.setState({ rentalItems: rentalItems });
	    };
	  };
	
	  RentalsPage.prototype.render = function render() {
	    var _this5 = this;
	
	    var rentalItems = this.state.rentalItems;
	
	    var total = 0;
	    var deposit = 0;
	    rentalItems.forEach(function (r) {
	      if (r.selected) {
	        total += r.cost * r.quantity;
	        if (r.deposit) {
	          deposit += r.deposit * r.quantity;
	        }
	      }
	    });
	
	    if (deposit > 200 && deposit < 500) {
	      deposit = 200;
	    } else if (deposit >= 500) {
	      deposit = 400;
	    }
	
	    return _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('meta', { charSet: 'utf-8' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          'Equipment Rental'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Rent barbells, weights, rowers and air bikes.' }),
	        _react2.default.createElement('link', { rel: 'canonical', href: 'https://crossfit-secaucus.com/rental' })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section section-basic' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 offset-md-2 col-lg-6 offset-lg-3' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'title text-center' },
	                'Equipment Rental'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'During the mandatory shutdown, we are making our training equipment available for rent. Complete this form as a first step to get your hands on what you need.'
	              ),
	              _react2.default.createElement('hr', null),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Rental Overview'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Free home delivery within local area for rental of $100+/week'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Rentals are week-to-week'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Minimum rental period is 3 weeks'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Equipment subject to availability. First come, first serve.'
	                )
	              ),
	              _react2.default.createElement('hr', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'table table-striped' },
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement('th', null),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Item'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'text-center' },
	                        'Quantity'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Cost'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rentalItems.map(function (r, idx) {
	                      return r.heading ? _react2.default.createElement(
	                        'tr',
	                        { key: idx },
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '4' },
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement('br', null),
	                            r.heading
	                          )
	                        )
	                      ) : _react2.default.createElement(RentalItemRow, {
	                        key: idx,
	                        label: r.label,
	                        cost: r.cost,
	                        quantity: r.quantity || '',
	                        selected: !!r.selected,
	                        multiple: r.multiple,
	                        onQuantityChange: _this5._handleQuantityChange(idx),
	                        onSelectChange: _this5._handleSelectChange(idx)
	                      });
	                    })
	                  )
	                ),
	                !total && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('hr', null),
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'text-center' },
	                    '\u261D\uFE0FSelect desired equipment from the list.'
	                  ),
	                  _react2.default.createElement('hr', null)
	                ),
	                total > 0 && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('hr', null),
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'text-center' },
	                    'Rate for all selected equipment: ',
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      '$',
	                      total,
	                      '/week'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-center', style: { padding: 0 } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      '($' + deposit + ' deposit required.)'
	                    )
	                  ),
	                  _react2.default.createElement('hr', null),
	                  total < 35 && _react2.default.createElement(
	                    'p',
	                    { className: 'text-center', style: { padding: 0 } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      '⚠️ $35 minimum rental rate not met.'
	                    )
	                  ),
	                  total >= 35 && _react2.default.createElement(
	                    'p',
	                    { className: 'text-center', style: { padding: 0 } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      total >= 100 ? '🚚 Free home delivery' : '🏢 Selection ready for pick-up weekdays at 6pm'
	                    )
	                  ),
	                  _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(_Contact2.default, {
	                  messageAddition: rentalItems.filter(function (r) {
	                    return r.selected;
	                  }).map(function (r) {
	                    return (r.quantity || 1) + 'x ' + r.label + ' ($' + r.cost + '/item)';
	                  }).join("\n") + ('\n\nWeekly Rate: $' + total + ' / Deposit $' + deposit),
	                  noCard: true,
	                  header: _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      '"How do I get my hands on the equipment?"'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Let us know you\'re interested by selecting the equipment you want to rent above and submitting the form below.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'For even faster service, after completing the form please ',
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'http://register.crossfit-secaucus.com/', target: '_blank' },
	                        'create an account for yourself'
	                      ),
	                      ' on our website and add your credit card information. (You won\'t get charged until you agree to the rental terms.)'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'You may pick up your equipment the same day (if your application is received before 3pm) or the next day at 6pm.'
	                    )
	                  ),
	                  submitLabel: 'Send Rental Request'
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return RentalsPage;
	}(_react2.default.Component);
	
	exports.default = RentalsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rental-js-1d6bb13af858d6715e63.js